import React, { FC, useEffect } from 'react';
import { AnalyticsSenderProvider, useAnalytics } from '@funtech-int/yango-shared';
import { useRouteMatch } from '@funtech-int/rival-react';

import { ClientError } from '@/shared/components/ClientError/ClientError';

import { useI18n } from '../../hooks/useI18n';
import { createMovieCardAnalytics } from '../../lib/movieCardAnalytics';
import { filmRoute } from '../../routes';

import styles from './MovieNotFound.module.css';

const MovieNotFoundComponent: FC = () => {
    const i18n = useI18n();
    const analytics = useAnalytics(createMovieCardAnalytics);
    const location = useRouteMatch(filmRoute);

    useEffect(() => {
        analytics.movieCardErrorRaised(location.params.id);
    }, [analytics, location.params.id]);

    return (
        <div className={styles.root}>
            <ClientError
                status={404}
                title={i18n('movie_not_found__title')}
                description={i18n('movie_not_found__description')}
            />
        </div>
    );
};

export const MovieNotFound: FC = () => (
    <AnalyticsSenderProvider>
        <MovieNotFoundComponent />
    </AnalyticsSenderProvider>
);
